export default __webpack_public_path__ + "static/media/ary-banner.8f6ba0cf.jpg";